import React, {Component} from 'react';
import {graphql, compose} from 'react-apollo';
import addressesQuery from 'graphql/queries/addresses.gql';
import addressQuery from 'graphql/queries/address.gql';
import updateAddressMutation from 'graphql/mutations/addresses/update-address.gql';
import Spinner from 'components/spinner';
import AddressForm from 'views/addresses/address-form';

@compose(
    graphql(addressQuery, {
        name: 'addressData',
        options: props => ({
            fetchPolicy: 'network-only',
            variables: {id: props.match.params.id},
        }),
    }),
    graphql(updateAddressMutation, {
        props: ({mutate, ownProps}) => ({
            updateAddress: variables => mutate({
                variables: {
                    ...variables,
                    id: ownProps.match.params.id,
                },
                refetchQueries: [{
                    query: addressesQuery,
                }],
            }),
        }),
    }),
)
export default class UpdateAddress extends Component {
    render() {
        if (this.props.addressData.loading) return <Spinner />;

        return (
            <AddressForm
                dataKey='updateAddress'
                address={this.props.addressData.address}
                onSubmit={this.props.updateAddress}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./views/addresses/update-address/index.js